import React, {useEffect, useState} from 'react';
import axios from 'axios';

export default function ApplicationMetrics() {
  const [metrics, setMetrics] = useState(null);
  const [error, setError] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/interests/response-metrics`, {timeout:15000,signal:controller.signal})
      .then(({data}) => {if (active && typeof data.applications === 'number') {setMetrics(data);setError(false);}})
      .catch(() => {if (active) setError(true);});
    return () => {active = false;controller.abort();};
  }, [reload]);
  return <div className="mb-5 border rounded-xl p-4 text-sm" aria-label="Başvuru yanıt ölçümleri">
    <strong>Başvurulara yanıt</strong>
    {metrics && <p>{metrics.applications} başvuru · {metrics.responded} yanıtlandı · {metrics.awaiting_first_response} ilk yanıtı bekliyor<br/>
      Ortalama ilk yanıt: {metrics.average_response_ms == null ? 'Henüz veri yok' : `${Math.round(metrics.average_response_ms / 60000)} dakika`}</p>}
    {metrics?.by_initiator && Object.entries(metrics.by_initiator).map(([role,data]) => <p key={role}>{role === 'venue' ? 'Mekânın gönderdiği' : 'Organizatörün gönderdiği'}: {data.applications} talep · {data.responded} ilk yanıt · Ortalama {data.average_response_ms == null ? 'henüz yok' : `${Math.round(data.average_response_ms / 60000)} dakika`}</p>)}
    <p className="text-xs mt-2">Ölçüm, bu güncellemeden sonra oluşturulan başvuruları kapsar. E-posta gönderimi okunma kanıtı değildir.</p>
    {error && <p role="alert">Yanıt ölçümleri yüklenemedi.</p>}
    <button className="text-action" onClick={() => setReload(n => n + 1)}>Ölçümleri yenile</button>
  </div>;
}
